import { useState } from "react";
import type { CastMember } from "@/mocks/films";

type CastListProps = {
  cast: CastMember[];
};

const avatarTone = [
  "bg-primary-100 text-primary-700",
  "bg-accent-100 text-accent-800",
  "bg-secondary-100 text-secondary-800",
  "bg-background-200 text-foreground-700",
];

const CastList = ({ cast }: CastListProps) => {
  const [activeIndex, setActiveIndex] = useState(0);

  return (
    <section>
      <div className="mb-4 flex items-center justify-between">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span className="flex h-5 w-5 items-center justify-center text-accent-600">
            <i className="ri-group-line" />
          </span>
          演员与角色
        </h2>
        <span className="text-xs text-foreground-400">共 {cast.length} 位主创</span>
      </div>

      <div className="grid grid-cols-1 gap-3 sm:grid-cols-2">
        {cast.map((member, index) => (
          <button
            key={`${member.name}-${member.role}`}
            type="button"
            onClick={() => setActiveIndex(index)}
            className={`flex cursor-pointer items-start gap-3 rounded-lg border p-3.5 text-left transition-colors ${
              activeIndex === index
                ? "border-primary-300 bg-primary-50/60"
                : "border-background-200/80 bg-background-50 hover:border-background-300"
            }`}
          >
            <span
              className={`flex h-11 w-11 shrink-0 items-center justify-center rounded-full font-heading text-base font-semibold ${
                avatarTone[index % avatarTone.length]
              }`}
            >
              {member.name.slice(0, 1)}
            </span>
            <span className="min-w-0">
              <span className="flex flex-wrap items-baseline gap-x-2">
                <span className="text-sm font-semibold text-foreground-950">{member.name}</span>
                <span className="text-xs text-foreground-500">饰 {member.role}</span>
              </span>
              <span className="mt-1 block text-xs leading-relaxed text-foreground-600">
                {member.note}
              </span>
            </span>
          </button>
        ))}
      </div>
    </section>
  );
};

export default CastList;